import { useEffect, useState, useMemo, memo, useRef } from "react";
import { useTranslation } from "react-i18next";
import {useNavigate} from 'react-router-dom'
import CountUp from "react-countup";
import classNames from "classnames";
import { Mask,Popup } from "antd-mobile";
import styles from "./index.module.scss";
import person from "../../images/index/logo.png";
import addres from "../../images/index/addres.png";
import bindroom from "../../images/index/bindroom.png";
import buy from "../../images/index/buy.png";
import chargestatement from "../../images/index/chargestatement.png";
import chargehistory from "../../images/index/chargehistory.png";
import explain from "../../images/index/explain.png";
import untieroom from "../../images/index/untieroom.png";
import seting from "../../images/index/seting.png";
import { getbindmonitorApi, delRoomApi, getWarningInfoApi } from "../../http/request";
import { modalConfirm, showLoading, modalAlert } from "../../component/Modal/index";
import { useStore, meterPorps } from "../../store/store";
type lng = "en" | "zh";
interface waringProps  {
  endTime?: string
  startTime?: string
  isShow?: number
}
function Index() {
  const navigate = useNavigate()
  const { i18n, t } = useTranslation();
  const [language, setLanguage] = useState<lng>("zh");
  const {buildingIsDisplayed, nkdSid, buildingid, username, updateallowfraction, updateBuildingName1,updateBuildingName2,updateisDisplayed, updateWaringMoney, updateBuildingName,updatebuildingNameEN, updateMeterList, updateMeterSetting,updateBuildingid, updateBuildingType } = useStore((state) => state);
  const [visible, setVisible] = useState<boolean>(false);
  const [visible1, setVisible1] = useState(false)
  const [visible2, setVisible2] = useState<boolean>(false);
  const [meterOptions, setMeterOptions] = useState<meterPorps[]>([]);
  const [popValue, setPopValue] = useState<Record<string, any>>({})
  const [roomName, setRoomName] = useState<Record<string, string>>({})
  const waringInfo = useRef({} as waringProps)
  /**
   * @description 实时点抄表计状态
   */
  const MaskContent = useMemo(() => {
    return <Mask visible={visible}>{showLoading()}</Mask>;
  }, [visible]);
  /**
   * @description 点击？显示详情
   */
  const popupElement = useMemo(() => {
    return <div className={styles.popup_view}>
      <div className={styles.item}>
        <div className={styles.label}>{t('ZGL')}</div>
        <div className={styles.value}>{popValue.totalpurchaseamount}</div>
      </div>
      <div className={styles.item}>
        <div className={styles.label}>{t('ZYL')}</div>
        <div className={styles.value}>{popValue.totalusedamount}</div>
      </div>
      <div className={styles.item}>
        <div className={styles.label}>{t('YL')}</div>
        <div className={styles.value}>{popValue.remainingquanlity}</div>
      </div>
      <div className={styles.item}>
        <div className={styles.label}>{t('update_time')}</div>
        <div className={styles.value}>{popValue.updateTime}</div>
      </div>
    </div>
  },[popValue, language])

  /**
   * @description 获取nginx下的warning.json内容
   */
  const getWarningInfo = async () => {
    const res = await getWarningInfoApi()
    waringInfo.current = {...res.data}
    isShowWarning()
  }
  const isShowWarning = async () => {
    if (waringInfo.current.isShow == 1) {
      await modalAlert({
        title: t("TS"),
        content: t("XTWHNR", {warningTime: `${waringInfo.current.startTime}-${waringInfo.current.endTime}`}),
        confirmText: t("ZDL"),
      });
    }
  }
  /**
   * @description 获取房间下表计信息
   */
  const getbindmonitor = async () => {
    const res = await getbindmonitorApi({
      nkdSid: nkdSid
    });
    if (res.data.code == 0) {
      const data = res.data.list;
      updateBuildingName(res.data.buildingName)
      updatebuildingNameEN(res.data.buildingNameEn)
      setRoomName({
        buildingName:res.data.buildingName,
        buildingNameEn: res.data.buildingNameEn
      })
      updateBuildingid(res.data.buildingID)
      updateBuildingType(res.data.buildingType)
      updateisDisplayed(res.data.buildingIsDisplayed)
      updateBuildingName1(res.data.buildingName1)
      updateBuildingName2(res.data.buildingName2)
      updateallowfraction(res.data.allowFraction)
      if (res.data.buildingIsDisplayed === 0) {
        setMeterOptions([])
        updateMeterList([])
      } else {
        let meterInfo = data.filter((item:Record<string, any>) => {
          return item.isUsed == 1 && item
        })
        setMeterOptions(meterInfo)
        updateMeterList(meterInfo)
      }
      //保存表计报警阈值
      updateWaringMoney({
        eleWarnMoney1: res.data.eleWarnMoney1 || '',
        eleWarnMoney2: res.data.eleWarnMoney2 || '',
        coldWaterWarnMoney1:  res.data.coldWaterWarnMoney1 || '',
        coldWaterWarnMoney2: res.data.coldWaterWarnMoney2 || '',
        hotWaterWarnMoney1:  res.data.hotWaterWarnMoney1 || '',
        hotWaterWarnMoney2:  res.data.hotWaterWarnMoney2 || ''
      })
      //保存表计单价
      updateMeterSetting({
      allowChargeEndTime: res.data.allowChargeTime.allowChargeEndTime, //充值时间-结束
      allowChargeStartTime: res.data.allowChargeTime.allowChargeStartTime, //充值时间-开始
      coldWaterPrice:  res.data.priceInfo.coldWaterPrice, //冷水表单价
      electricityPrice: res.data.priceInfo.electricityPrice, //电表单价
      hotWaterPrice: res.data.priceInfo.hotWaterPrice // 热水单价
      })
      return
    }
    
  };
  /**
   * @description 切换语言
   * @param lng
   */
  const changeLanguage = (lng: lng) => {
    window.localStorage.setItem("language", lng);
    setLanguage(lng);
    i18n.changeLanguage(lng);
  };
  /**
   * @description 初始化获取语言设置
   */
  const initLanguage = () => {
    const language = window.localStorage.getItem("language")
      ? window.localStorage.getItem("language")
      : "zh";
    setLanguage(language as lng);
    i18n.changeLanguage(language as string);
  };
  /**
   * @description 各模块路由跳转
   * @param path 
   * @returns 
   */
  const toRoute = async (path: any) => {
    if(!buildingid && path != '/bindroom') {
      await modalAlert({
        title: t("TS"),
        content: t("NOTBUNDROOM"),
        confirmText: t("ZDL"),
      });
      return;
    }
   if (buildingIsDisplayed !== 1 && path != '/bindroom') {
    await modalAlert({
      title: t("TS"),
      content: <div dangerouslySetInnerHTML={{ __html: t("ZTCZROOM") }}></div>,
      confirmText: t("ZDL"),
    });
   }
    navigate(path)
  };
  /**
   * @description 解绑房间
   */
  const unBind = async () => {
    if (!buildingid) {
      await modalAlert({
        title: t("TS"),
        content: t("NOTBUNDROOM"),
        confirmText: t("ZDL"),
      });
      return;
    }
    const res = await modalConfirm({
      title: t("TS"),
      content: t("FJJBTEXT"),
      confirmText: t("QD"),
      cancelText: t("QX"),
    });
    if (res) {
      const result = await delRoomApi({
        buildingid: buildingid,
        nkdSid: nkdSid,
      });
      if (result.data.code == 0) {
        updateBuildingName("");
        updatebuildingNameEN('')
        setMeterOptions([]);
        updateMeterList([])
        updateBuildingid('')
          setRoomName({
            buildingName:'',
            buildingNameEn: ''
          })
        await modalAlert({
          title: t("TS"),
          content: t("JBCG"),
          confirmText: t("ZDL"),
        });
        return;
      }
      await modalAlert({
        title: t("TS"),
        content: result.data.msg,
        confirmText: t("ZDL"),
      });
    }
  };
  /**
   * @description 获取表计类型
   */
  const getMeterType = (type: string) => {
    let meterType = ''
    switch(type) {
      case '电表': meterType =  t('dbyl')
      break;
      case '冷水表': meterType =  t('sbyl1')
      break
      case '热水表': meterType =  t('sbyl2')
      break
      default: {}
    }
    return meterType
  }
  /**
   * @description 实时刷新表计
   */
  const updateMeter = async () => {
    const res = await modalConfirm({
      title: t("TS"),
      content: t("SFSXBJ"),
      confirmText: t("QD"),
      cancelText: t("QX"),
    });
    if (res) {
      setVisible(true);
    }
  };
  /**
   * @description 获取表计更多信息
   */
  const getMoreInfo = async () => {};
  const mockContent = (
    <div style={{ padding: 20 }}>
    </div>
  )
  /**
   * @description 一个表计
   * @returns 
   */
  const OneMeterElement = () => {
    return (
      <div className={styles.oneElement}>
            <div className={styles.one_meter_view}>
            <div className={styles.detail} /* onClick={() => {popup(meterOptions[0])}} */>
              <p>
              {`${getMeterType(meterOptions[0].energyType)}`}&nbsp;({t("MONETARY_UNIT")})
              </p>
              &nbsp;
          {/*     <img  style={{width:'15px', height: '15px'}}  src={more} alt="" /> */}
            </div>
            <CountUp
              className={styles.elect_view_number}
              start={0}
              end={
                meterOptions.length > 0 ? meterOptions[0].remainingamount : 0
              }
              duration={0.5}
              decimals={2}
            />
      {/*       <div
              onClick={() => {
                updateMeter();
              }}
              className={styles.updaten_number}
            >
              刷新表计状态(剩余次数10)
            </div> */}
          </div>
      </div>
    )
  }
   /**
   * @description 两个表计
   * @returns 
   */
  const TwoMeterElement = () => {
    return (
      <div className={styles.twoMeterElement}>
           <div
            className={classNames(styles.two_meter_view)}
            style={{padding: language == "en" ? '0 5vw': '0 8vw'}}
          >
            <div className={styles.water_deatil}>
            <div className={styles.detail} /* onClick={() => {popup(meterOptions[0])}} */>
            <p  style={{ fontSize: "16px" ,marginBottom:'5px'}}>
                {`${getMeterType(meterOptions[0].energyType)}  (${t("MONETARY_UNIT")})`}&nbsp;
               {/*  <img style={{width:'15px', height: '15px'}} onClick={() => getMoreInfo()} src={more} alt="" /> */}
              </p>
                   <Popup
              visible={visible1}
              onMaskClick={() => {
                setVisible1(false)
              }}
              onClose={() => {
                setVisible1(false)
              }}
              bodyStyle={{ height: '40vh' }}
            >
              {mockContent}
            </Popup>
            </div>
              <p
                style={{ fontSize: "18px" }}
                className={styles.water_view_number}
              >
                <CountUp
                  className={styles.elect_view_number}
                  style={{color: '#EB6C00'}}
                  start={0}
                  end={meterOptions[0].remainingamount}
                  duration={0.5}
                  decimals={2}
                />
              </p>
          {/*     <p>{meterOptions[0].updateTime}</p> */}
            </div>
            <div className={styles.water_deatil}>
            <div className={styles.detail} /* onClick={() => {popup(meterOptions[1])}} */> 
            <p  style={{ fontSize: "16px" ,marginBottom:'5px'}}>
              {`${getMeterType(meterOptions[1].energyType)}  (${t("MONETARY_UNIT")})`}
              &nbsp;
             {/*  <img style={{width:'15px', height: '15px'}} onClick={() => getMoreInfo()} src={more} alt="" /> */}
              </p>
           </div>
              <p
                style={{ fontSize: "18px" }}
                className={styles.water_view_number}
              >
                <CountUp
                  className={styles.elect_view_number}
                  style={{color: '#EB6C00'}}
                  start={0}
                  end={meterOptions[1].remainingamount}
                  duration={0.5}
                  decimals={2}
                />
              </p>
             {/*  <p>{meterOptions[1].updateTime}</p> */}
            </div>
          </div>
      </div>
    )
  }
  /**
   * @description 三个表计
   * @returns 
   */
  const ThreeMeterElement = () => {
    return (
      <div>
          <div className={styles.one_meter_view}>
            <div className={styles.detail} /* onClick={() => {popup(meterOptions[0])}} */>
              <p>
                {`${getMeterType(meterOptions[0].energyType)}` }{" "}
                {language == "zh" ? `(${t("MONETARY_UNIT")})` : null}&nbsp;
              </p>
              &nbsp;
           {/*    <img  style={{width:'15px', height: '15px'}}  src={more} alt="" /> */}
            </div>
            <p
                
                className={styles.elect_view_number}
              >
            <CountUp
            
              start={0}
              end={
                meterOptions.length > 0 ? meterOptions[0].remainingamount : 0
              }
              duration={0.5}
              decimals={2}
            />
              &nbsp;{language == "en" ? t("MONETARY_UNIT") : null}
              </p>
           {/*  <p>{meterOptions[0].updateTime}</p> */}
      {/*       <div
              onClick={() => {
                updateMeter();
              }}
              className={styles.updaten_number}
            >
              刷新表计状态(剩余次数10)
            </div> */}
          </div>
          <div
            className={classNames(styles.two_meter_view, {
              [styles.languagePadding]: language == "en",
              [styles.has2]: false,
            })}
          >
            <div className={styles.water_deatil}>
              <p className={styles.detail} /* onClick={() => {popup(meterOptions[1])}} */>
                {getMeterType(meterOptions[1].energyType)}{" "}
                {language == "zh" ? `(${t("MONETARY_UNIT")})` : null}&nbsp;
              {/*   <img  style={{width:'15px', height: '15px'}}   src={more} alt="" /> */}
              </p>
              <p
                style={{ fontSize: "18px" }}
                className={styles.water_view_number}
              >
                <CountUp
                  className={styles.elect_view_number}
                  start={0}
                  end={ meterOptions[1].remainingamount}
                  duration={0.5}
                  decimals={2}
                />
                &nbsp;{language == "en" ? t("MONETARY_UNIT") : null}
              </p>
            {/*   <p>{meterOptions[1].updateTime}</p> */}
            </div>
            <div className={styles.water_deatil}>
              <p className={styles.detail} /* onClick={() => {popup(meterOptions[2])}} */>
                {getMeterType(meterOptions[2].energyType)}{" "}
                {language == "zh" ? `(${t("MONETARY_UNIT")})` : null}&nbsp;
            {/*     <img  style={{width:'15px', height: '15px'}}  src={more} alt="" /> */}
              </p>
              <p
                style={{ fontSize: "18px" }}
                className={styles.water_view_number}
              >
                <CountUp
                  className={styles.elect_view_number}
                  start={0}
                  end={meterOptions[2].remainingamount}
                  duration={0.5}
                  decimals={2}
                />
                &nbsp;{language == "en" ? t("MONETARY_UNIT") : null}
              </p>
            {/*   <p>{meterOptions[2].updateTime}</p> */}
            </div>
          </div>
      </div>
    )
  }
  const MeterElement =  useMemo(() => {
    let element = null
    const len = meterOptions.length
    switch(len) {
      case 0 : break;
      case 1 : element = <OneMeterElement />
      break
      case 2 : element = < TwoMeterElement />
      break
      case 3 : element = <ThreeMeterElement />
      break;
      default: {}
    }
    return element
  },[meterOptions.length,language])
  useEffect(() => {
    if (!nkdSid) {
      navigate('/login')
      return
    }
    document.title = t('title1')
    initLanguage();
   // getWarningInfo()
    getbindmonitor();
  }, []);
  return (
    <div className={styles.main_container}>
      <div className={styles.head}>
        <div className={styles.person_view}>
        <img  className={styles.person_img} style={{width:'50px', height: '50px'}}  src={person} alt="" />
          <div className={styles.person_info}>
            <p style={{marginLeft: '9px'}}>{username}</p>
            <div className={styles.person_addres}>
            <img   style={{width:'9px', height: '12px'}}  src={addres} alt="" />
              <p>{language == "en"? roomName.buildingNameEn: roomName.buildingName}</p>
            </div>
          </div>
          <div className={styles.language_view}>
            <div
              className={classNames({
                [styles.moveColorLeft]: language == "zh",
                [styles.moveColorReft]: language == "en",
              })}
            >
              {language == "zh" ? "中文" : "EN"}
            </div>
            <div
              onClick={() => {
                changeLanguage("zh");
              }}
            >
              中文
            </div>
            <div
              onClick={() => {
                changeLanguage("en");
              }}
            >
              EN
            </div>
          </div>
        </div>
        <div className={styles.meter_view}>
         {MeterElement}
        </div>
      </div>
      <div className={styles.update_view}>{meterOptions.length > 0?`${t('update_time')} ${meterOptions[0].updateTime}`: null}</div>
      <div className={styles.menu_container}>
        <div className={styles.title_view}>
          <div className={styles.title_icon}></div>
          <p>{t("CYGN")}</p>
        </div>
        <div className={styles.menu_view}>
          <div
            className={styles.menu_item}
            onClick={() => {
              toRoute("/bindroom");
            }}
          >
             <img   style={{width:'60px', height: '60px'}}  src={bindroom} alt="" />
            <p>{t("BDFJ")}</p>
          </div>
          <div
            className={styles.menu_item}
            onClick={() => {
              toRoute("/Instructions");
            }}
          >
              <img   style={{width:'60px', height: '60px'}}  src={explain} alt="" />
            <p>{t("SM")}</p>
          </div>
          <div
            className={styles.menu_item}
            onClick={() => {
              toRoute("/charge");
            }}
          >
              <img   style={{width:'60px', height: '60px'}}  src={buy} alt="" />
            <p>{t("GSGD")}</p>
          </div>
          <div
            className={styles.menu_item}
            onClick={() => {
              toRoute("/paymenthistory");
            }}
          >
                <img   style={{width:'60px', height: '60px'}}  src={chargehistory} alt="" />
            <p>{t("JFLS")}</p>
          </div>
          <div
            className={styles.menu_item}
            onClick={() => {
              toRoute("/consumptionflow");
            }}
          >
            <img   style={{width:'60px', height: '60px'}}  src={chargestatement} alt="" />
            <p>{t("XFLS")}</p>
          </div>
          <div
            className={styles.menu_item}
            onClick={() => {
              unBind();
            }}
          >
             <img   style={{width:'60px', height: '60px'}}  src={untieroom} alt="" />
            <p>{t("FJJB")}</p>
          </div>
          <div
            className={styles.menu_item}
            onClick={() => {
              toRoute("/seting");
            }}
          >
              <img   style={{width:'60px', height: '60px'}}  src={seting} alt="" />
            <p>{t("SZ")}</p>
          </div>
        </div>
      </div>
      {MaskContent}
      <Popup
    visible={visible2}
    onMaskClick={() => {
      setVisible2(false)
    }}
  >
    <div
      style={{ height: '35vh', overflowY: 'scroll', padding: '20px' }}
    >
    {popupElement}
    </div>
  </Popup>
    </div>
  );
}

export default memo(Index);
